/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Formulas_AfterInputs */

const en_gc_guides_formulas_after = /** @type {(inputs: Gc_Guides_Formulas_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try another threshold in the IF expression, then restore the original condition and compare the result. The lines beginning with // in the example are explanations, not text to paste into a cell. Once the small example works, apply the same pattern to a budget or a grade tracker. If a formula behaves unexpectedly, inspect its range and input types first. Check specialist Excel functions individually rather than assuming that a long function list guarantees complete compatibility.`)
};

const zh_gc_guides_formulas_after = /** @type {(inputs: Gc_Guides_Formulas_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尝试修改 IF 的阈值，再恢复原条件比较结果。示例中以 // 开头的是解释，不要粘贴进单元格。确认小示例正常后，可以将同样的方法用于预算或成绩表。公式异常时，先检查引用范围与输入类型。对于专业 Excel 函数，应逐个核实兼容性。`)
};

/**
* | output |
* | --- |
* | "Try another threshold in the IF expression, then restore the original condition and compare the result. The lines beginning with // in the example are explan..." |
*
* @param {Gc_Guides_Formulas_AfterInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_formulas_after = /** @type {((inputs?: Gc_Guides_Formulas_AfterInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Formulas_AfterInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_formulas_after(inputs)
	return zh_gc_guides_formulas_after(inputs)
});
export { gc_guides_formulas_after as "gc.guides.formulas.after" }